
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Component({})
export default class PriceLink extends Vue {
    @Getter('priceLink')
    readonly priceLink!: string

    @Action('loadPriceLink')
    loadPriceLink!: () => Promise<void>

    private priceLinkStatus = ''
    async created (): Promise<void> {
        try {
            await this.loadPriceLink()
            this.priceLinkStatus = this.priceLink.length ? 'success' : 'not_found'
        } catch (e) {
            this.priceLinkStatus = 'error'
        }
    }

    private copyLink (): void {
        (this.$refs.linkContainer as Vue).$el.getElementsByTagName('input')[0].select()
        document.execCommand('copy')
    }
}
